import { recommendations } from '../../portfolio';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './Recommendations.css';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const RecommendationContainer = ({ recommendation }) => {
  const {
    profile,
    name,
    position,
    company,
    link,
    description = '',
    linkedin = '',
  } = recommendation;

  return (
    <div className='rec-container glass-card'>
      <img
        alt="recommender's profile pic"
        className='rec-container__img'
        src={profile}
      />
      <div className='rec-container__info-wrap'>
        <div className='rec-container__desc'>&ldquo;{description}&rdquo;</div>

        <div className='rec-container__name'>
          <a href={linkedin} aria-label='linkedin profile' className='linkedin'>
            <LinkedInIcon />
          </a>
          {name}
        </div>
        <div className='rec-container__details'>
          <span>{position},</span>
          <a href={link} target='_blank' rel='noreferrer' className='link-effect'>
            <span className='rec-container__compnay'>{company}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

const Recommendations = () => {
  if (!recommendations.length) return null;

  const isDesktopView = !window.matchMedia('(max-width:750px)').matches;

  return (
    <section id='recommendations' className='section recommendations'>
      <ScrollReveal>
        <h2 className='section__title'>Recommendations</h2>
      </ScrollReveal>
      <ScrollReveal delay={150}>
        <ul className='reccomendation__list'>
          <Carousel
            showArrows={true}
            preventMovementUntilSwipeScrollTolerance={true}
            emulateTouch={isDesktopView}
            infiniteLoop={true}
            autoPlay={isDesktopView}
            interval={6000}
            showThumbs={false}
            swipeable={isDesktopView}
            stopOnHover={true}
          >
            {recommendations.map((recommendation) => (
              <div className='reccomendation__list-item' key={recommendation.name}>
                <RecommendationContainer recommendation={recommendation} />
              </div>
            ))}
          </Carousel>
        </ul>
      </ScrollReveal>
    </section>
  );
};

export default Recommendations;
